module.exports = __webpack_public_path__ + "img/press-bg-2.acba685a.svg";